module.exports = __webpack_public_path__ + "assets-cabinet/img/camera.7eece7ec.svg";